import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[alphaNumWithSpace]',
  standalone: false  //NOSONAR
})
export class AlphaNumWithSpaceDirective {
  private el = inject(ElementRef);

  regStr = '^[a-zA-Z0-9 ]*$';

  @HostListener('keypress', ['$event'])
  checkAlphaNumWithSpace(event) {
    return new RegExp(this.regStr).test(String.fromCharCode(event.keyCode));
  }

  @HostListener('paste', ['$event'])
  blockPaste(event: ClipboardEvent) {
    this.validateInput(event);
  }

  validateInput(event: ClipboardEvent) {
    event.preventDefault();
    const pasteData = event.clipboardData?.getData('text/plain').replace(/[^a-zA-Z0-9 ]/g, '');
    document.execCommand('insertHTML', false, pasteData);
  }
}
